import { useRouter } from "next/router";
import { useMemo } from "react";

const useBlogTagSlug = (articleTags: any) => {
  const { query, pathname } = useRouter();
  const hreflangs = useMemo(() => {
    const handlePath = (slug: string) => pathname.replace("[slug]", slug);
    const currentTag = articleTags.find(
      (item: any) => item.attributes.slug === query.slug
    );

    const locales = currentTag.attributes.localizations.data?.map(
      (local: any) => ({
        locale: local.attributes.locale.toLowerCase(),
        path: handlePath(local.attributes.slug),
      })
    );
    return [
      {
        locale: currentTag.attributes.locale.toLowerCase(),
        path: handlePath(currentTag.attributes.slug),
      },
      ...locales,
    ];
  }, [articleTags]);
  return hreflangs;
};

export default useBlogTagSlug;
